<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Quản lý Sim</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />

        <button @click="downFileList" class="btn f12 no-padding btn-outline-secondary">
          <i class="bx bx-download"></i>Xuất file
        </button>

        <b-dropdown toggle-class="font-medium f12 no-padding drropdown-export">
          <template #button-content> <i class="bx bx-download"></i> Tải file mẫu </template>
          <b-dropdown-item @click="handleImportOrExportSim('export', 'NEEDRENEWAL')">
            <i class="bx bx-download"></i>File mẫu sim cần gia hạn
          </b-dropdown-item>
          <b-dropdown-item @click="handleImportOrExportSim('export', 'RENEWED')">
            <i class="bx bx-download"></i>File mẫu sim đã gia hạn
          </b-dropdown-item>
        </b-dropdown>
        <b-dropdown
          v-if="dataPermission && dataPermission?.includes('SCON_SIM_MANAGE_IMPORT_FILE')"
          toggle-class="font-medium f12 no-padding drropdown-import"
        >
          <template #button-content> <i class="bx bx-plus-circle"></i> Import file </template>

          <b-dropdown-item
            v-for="item in importTypes"
            :key="`dropdown-${item.key}`"
            @click="triggerImport(item.key)"
          >
            <i class="bx bx-plus-circle"></i>{{ item.label }}
          </b-dropdown-item>
          <input
            type="file"
            ref="inputRefs"
            @change="handleImportFile"
            accept=".xlsx, .xls"
            style="display: none"
          />
        </b-dropdown>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <FilterSimForm @change="handleFilter" ref="filterSimForm" />
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><span class="text-muted">Tổng số</span>: {{ total }}</span>
            <div
              v-if="isDefaultTimeFilter"
              class="mb-2 d-inline-flex align-items-center ml-2"
              style="
                background-color: rgb(255, 243, 224);
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: rgb(245, 124, 0)"></i>
              <span style="color: rgb(230, 81, 0)">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                type="button"
                title="Bỏ lọc"
                class="ml-2 btn-close-filter"
                @click="clearDefaultFilter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0px 4px;
                  color: rgb(230, 81, 0);
                  font-size: 16px;
                  line-height: 1;
                "
              >
                ×
              </button>
            </div>
            <div class="table-responsive">
              <b-table
                :busy.sync="isTableLoading"
                sticky-header="800px"
                hover
                :items="dataListSim"
                :fields="filterTable"
                bordered
                show-empty
                responsive
                class="nowrap-table"
                style="min-width: 100%"
              >
                <template #table-busy>
                  <div class="my-2 text-center">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #empty>
                  <div class="text-center text-info my-2">Không có dữ liệu</div>
                </template>
                <template #cell(index)="data">
                  {{ getIndex(data.index) }}
                </template>
                <template #cell(SimInfor)="data">
                  <p>
                    <span class="text-muted">Nhà cung cấp: </span
                    >{{ Config.listOptionSupplierSim[data.item.supplier] }}
                  </p>
                  <p>
                    <span class="text-muted">Serial Sim: </span
                    >{{ data.item.serial ?? 'Thiếu serial sim' }}
                  </p>
                  <p><span class="text-muted">Số thuê bao: </span>{{ data.item.number }}</p>
                </template>
                <template #cell(MCInfor)="data">
                  <p><span class="text-muted">Tên: </span>{{ data.item.customerName }}</p>
                  <p>
                    <span class="text-muted">Email/SĐT: </span
                    >{{ data.item.customerEmail ?? data.item.customerPhone }}
                  </p>
                </template>
                <template #cell(ComboInfor)="data">
                  <p><span class="text-muted">Mã gói cước: </span>{{ data.item.packageCode }}</p>
                  <p>
                    <span class="text-muted">Dung lượng: </span>
                    {{ data.item.capacity ?? 'Chưa cập nhật được dung lượng của gói' }}
                  </p>
                </template>
                <template #cell(validity)="data">
                  <p>
                    <span class="text-muted">Ngày kích hoạt: </span
                    >{{ data.item.activeDate | formatDate }}
                  </p>
                  <p>
                    <span class="text-muted">Ngày hết hạn: </span
                    >{{ data.item.expiredDate | formatDate }}
                  </p>
                </template>
                <template #cell(StoreKeeper)="data">
                  <p>
                    {{ data.item.keeperName }}
                    <span v-show="data.item.keeperName && data.item.keeperEmail">-</span>
                    {{ data.item.keeperEmail }}
                  </p>
                </template>

                <template #cell(StatusSim)="data">
                  <b-badge
                    v-if="data.item.simStatus"
                    :variant="getSimStatusVariant(data.item.simStatus)"
                  >
                    {{ getSimStatusText(data.item.simStatus) }}
                  </b-badge>
                </template>

                <template #cell(status)="data">
                  <b-badge v-if="data.item.status" :variant="getStatusVariant(data.item.status)">
                    {{ getStatusText(data.item.status) }}
                  </b-badge>
                </template>
                <template #cell(errorReason)="data">
                  <p>{{ data.item.errorReason }}</p>
                </template>
                <template #cell(vendor)="data">
                  <p>
                    {{ data.item.source === 'Nextpay' ? data.item.source : 'Không thuộc Nextpay' }}
                  </p>
                </template>
                <template #cell(updateBySource)="data">
                  <p v-if="data.item?.updateBySource">{{ data.item.updateBySource }}</p>
                </template>

                <template #cell(createdDate)="data">
                  <p v-if="data.item.createdDate">{{ data.item.createdDate | formatDate }}</p>
                </template>

                <template #cell(lastModifiedDate)="data">
                  <p v-if="data.item.lastModifiedDate">
                    {{ data.item.lastModifiedDate | formatDate }}
                  </p>
                </template>
                <template #cell(ValidateInfor)="data">
                  <b-badge
                    v-if="data.item.authenStatus"
                    :variant="getAuthenStatusVariant(data.item.authenStatus)"
                  >
                    {{ getAuthenStatusText(data.item.authenStatus) }}
                  </b-badge>
                </template>
                <template #cell(PersonUpdate)="data">
                  <p>
                    {{ data.item.lastUpdate }}
                    <span v-show="data.item.lastUpdate && data.item.lastUpdateBy">-</span>
                    {{ data.item.lastUpdateBy }}
                  </p>
                </template>

                <template #cell(action)="data">
                  <b-dropdown class="text-center" variant="outline-light">
                    <b-dropdown-item
                      type="button"
                      class="dropdown-item"
                      :href="`/management-sim/${data?.item?.serial}`"
                      target="_blank"
                    >
                      Chi tiết
                    </b-dropdown-item>
                    <b-dropdown-item
                      type="button"
                      class="dropdown-item"
                      v-if="data?.item?.authenStatus !== 'VERIFIED'"
                      @click="openModalUpdateMC(data.item.serial)"
                    >
                      Cập nhật MC cho Sim
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <b-form-group class="mb-0" style="padding: 17px">
          <b-form-select
            v-model="fieldsSearch.limit"
            :options="pageOptions"
            @change="onItemsPerPageChange"
          ></b-form-select>
        </b-form-group>
        <b-pagination
          class="mr-2 fl-right"
          v-model="fieldsSearch.page"
          :total-rows="total"
          :per-page="fieldsSearch.limit"
          @change="onChangePage"
        ></b-pagination>
      </div>
    </div>
    <UpdateInforSimCard ref="refUpdateSimCard" @success="fetchData" />
    <ModalImportResult ref="refImportResult" />
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import Config from '@/thirdParty/config'
  import { DeviceService } from '@/services/device.service'
  import cloneDeep from 'lodash/cloneDeep'
  import { mapGetters } from 'vuex'
  import { showMess } from '@/config/utils'
  import UpdateInforSimCard from './components/UpdateInforSimCard.vue'
  import ModalImportResult from './components/ModalImportResult.vue'
  import FilterSimForm from './components/FilterSimForm.vue'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'SimInfor', label: 'Thông tin sim' },
    { key: 'MCInfor', label: 'Thông tin MC' },
    { key: 'ComboInfor', label: 'Thông tin gói sim' },
    { key: 'validity', label: 'Ngày' },
    { key: 'StoreKeeper', label: 'Thủ kho' },
    {
      key: 'StatusSim',
      label: 'Tình trạng sim',
    },
    {
      key: 'status',
      label: 'Trạng thái sim',
    },
    {
      key: 'errorReason',
      label: 'Lý do lỗi',
      thStyle: { 'min-width': '180px' },
      tdClass: 'break-word',
    },
    { key: 'vendor', label: 'Đơn vị bán' },
    { key: 'ValidateInfor', label: 'Đã xác thực thông tin' },
    { key: 'PersonUpdate', label: 'Người cập nhật' },
    { key: 'updateBySource', label: 'Nguồn cập nhật' },
    { key: 'createdDate', label: 'Ngày tạo' },
    { key: 'lastModifiedDate', label: 'Ngày cập nhật' },
    { key: 'action', label: 'Thao tác', class: 'text-center' },
  ]
  const importTypes = [
    { key: 'NEEDRENEWAL', label: 'Import file sim cần gia hạn' },
    { key: 'RENEWED', label: 'Import file sim đã gia hạn' },
  ]
  const searchFieldDefault = Object.freeze({
    page: 1,
    limit: 20,
  })
  const pageOptions = [
    { value: 20, text: '20/trang' },
    { value: 50, text: '50/trang' },
    { value: 100, text: '100/trang' },
    { value: 200, text: '200/trang' },
  ]

  export default {
    components: {
      UpdateInforSimCard,
      ModalImportResult,
      FilterSimForm,
    },
    data() {
      return {
        loading: false,
        isTableLoading: true,
        dataListSim: [],
        total: 0,
        fieldsTable,
        filterTable: fieldsTable,
        Config,
        importResultData: null,
        importTypes,
        currentImportType: null,
        fieldsSearch: cloneDeep(searchFieldDefault),
        pageOptions,
        isDefaultTimeFilter: false,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getStatusVariant() {
        return status => {
          const map = Config.statusDevices?.reduce((acc, curr) => {
            acc[curr.id] = curr.variant
            return acc
          }, {})
          return map[status] || 'primary'
        }
      },
      getStatusText() {
        return code => {
          const map = Config.statusDevices?.reduce((acc, curr) => {
            acc[curr.id] = curr.text
            return acc
          }, {})
          return map[code] || code
        }
      },
      getSimStatusVariant() {
        return status => {
          const map = Config.listOptionStatus?.reduce((acc, curr) => {
            acc[curr.id] = curr.variant
            return acc
          }, {})
          return map[status] || 'primary'
        }
      },
      getSimStatusText() {
        return code => {
          const map = Config.listOptionStatus?.reduce((acc, curr) => {
            acc[curr.id] = curr.text
            return acc
          }, {})
          return map[code] || code
        }
      },
      getAuthenStatusVariant() {
        return code => {
          const map = Config.listOptionAuthenStatusFilter?.reduce((acc, curr) => {
            acc[curr.id] = curr.bgColor
            return acc
          }, {})
          return map[code] || 'primary'
        }
      },
      getAuthenStatusText() {
        return code => {
          const map = Config.listOptionAuthenStatusFilter?.reduce((acc, curr) => {
            acc[curr.id] = curr.text
            return acc
          }, {})
          return map[code] || code
        }
      },
    },
    methods: {
      async onChangePage(page) {
        this.fieldsSearch.page = page
        await this.fetchData()
      },
      async onItemsPerPageChange() {
        this.fieldsSearch.page = 1
        await this.fetchData()
      },
      async handleFilter(payload) {
        this.fieldsSearch = { ...searchFieldDefault, ...payload }
        this.checkDefaultTimeFilter()
        await this.fetchData()
      },
      checkDefaultTimeFilter() {
        const hasExpiredDateFrom = this.fieldsSearch.expiredDateFrom
        const hasExpiredDateTo = this.fieldsSearch.expiredDateTo
        this.isDefaultTimeFilter = hasExpiredDateFrom && hasExpiredDateTo
      },
      clearDefaultFilter() {
        this.$refs.filterSimForm.clearTime(this.$refs.filterSimForm.fieldSearch.expiredDate)
        this.$refs.filterSimForm.triggerFilter()
      },
      triggerImport(type) {
        this.currentImportType = type
        this.$refs.inputRefs.click()
      },
      handleImportFile(event) {
        const type = this.currentImportType
        this.handleImportOrExportSim('import', type, event)
        this.currentImportType = null
        this.$refs.inputRefs.value = ''
      },
      openModalUpdateMC(serial) {
        this.$refs.refUpdateSimCard.openModal(serial)
      },
      async downFileList() {
        showMess(
          this,
          'Loading...',
          'Đang tải file danh sách sim',
          'warning',
          'b-toaster-top-right',
          3000
        )
        try {
          const body = { ...this.fieldsSearch }
          await DeviceService.dowFileSimExcel(body)
          showMess(
            this,
            'Thành công',
            'Đã tải xuống thành công',
            'success',
            'b-toaster-top-right',
            3000
          )
        } catch (error) {
          showMess(
            this,
            'Error',
            error.message || 'Tải xuống file mẫu thất bại',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      async fetchData() {
        const body = { ...this.fieldsSearch }
        try {
          this.isTableLoading = true
          const res = await DeviceService.listSimCard(body)
          if (res.code === 1000) {
            this.total = res.totalPage.total
            this.dataListSim = res.data
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 3000)
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        } finally {
          this.isTableLoading = false
        }
      },

      getIndex(index) {
        return (this.fieldsSearch.page - 1) * this.fieldsSearch.limit + index + 1
      },

      async handleImportOrExportSim(action, type, event) {
        const handleImport = async (func, callbackErr) => {
          const file = event?.target?.files?.[0]
          if (!file) return callbackErr('Vui lòng chọn file')
          const formData = new FormData()
          formData.append('file', file)

          const fileType = file.name.split('.').pop().toLowerCase()
          if (fileType !== 'xlsx' && fileType !== 'xls') {
            return callbackErr('Vui lòng chọn file Excel (.xlsx, .xls)')
          }

          const response = await func(formData)
          if (response.code === 1000) {
            this.$refs.refImportResult.openModal(
              response.data?.correctList.length,
              response.data?.errorList.length,
              response.data.errorList,
              type === 'NEEDRENEWAL'
                ? DeviceService.downloadFileNeedRenewalError
                : DeviceService.downloadFileRenewedError,
              DeviceService
            )
          }
        }

        const handleExport = async (func, callbackErr) => {
          await func()
        }

        const actionMap = {
          import: {
            api: {
              NEEDRENEWAL: DeviceService.ImportFileNeedRenewalSim,
              RENEWED: DeviceService.ImportFileRenewedSim,
            },
            handle: handleImport,
          },
          export: {
            api: {
              NEEDRENEWAL: DeviceService.exportListSimNeedRenewal,
              RENEWED: DeviceService.exportListSimRenewed,
            },
            handle: handleExport,
          },
        }

        const actionMapping = actionMap[action]
        if (!actionMapping) return
        const func = actionMapping.api[type]
        if (!func) return

        try {
          this.loading = true
          await actionMapping.handle(func.bind(DeviceService), message => {
            showMess(this, 'Error', message, 'danger', 'b-toaster-top-right', 3000)
          })
        } catch (err) {
          showMess(
            this,
            'Error',
            err.response?.data?.message || err.response?.message || err.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped>
  .nowrap-table {
    width: 100%;
    margin-bottom: 0;
  }

  .nowrap-table ::v-deep td {
    white-space: nowrap;
    padding: 0.5rem;
  }

  .nowrap-table ::v-deep td.break-word {
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  .nowrap-table ::v-deep p {
    margin-bottom: 0.25rem;
  }

  ::v-deep(.no-padding.dropdown-toggle) {
    padding: 0px 25px 0px 12px !important;
    background-color: transparent;
    color: #6c757d;
  }

  ::v-deep(.no-padding.dropdown-toggle):hover {
    background-color: #6c757d;
    color: white;
  }

  ::v-deep(.dropdown-toggle:focus),
  ::v-deep(.dropdown-toggle:focus-visible) {
    outline: none !important;
    box-shadow: none !important;
  }

  ::v-deep(.dropdown-menu:focus),
  ::v-deep(.dropdown-menu:focus-visible) {
    outline: none !important;
  }

  .action-h {
    height: 41px;
  }
</style>
